import React, { useState, useEffect, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { RemoveIcon } from '../../../assets/images'
import { useForm } from "react-hook-form";
import { onNumberOnlyChange, onSpecialChangeOnly } from '../EntityConfigUtils/entityConfigUtils';
import { addInterfaceDetails, addSiteAddress, Addsitedetails,  updateSiteAddress, Updatesitedetails } from '../../../services/configurationServices';
import { useCountry } from '../../../CustomHooks/useCountry';
import { useSiteType } from '../../../CustomHooks/useSiteType';
import { checkspecialcharacters, ConvertDate } from '../../../utils/utils';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { nearbyresource } from '../../../services/chatFlowService';
import { HIDE_ANALYTICS } from '../../../config';
import Swal from 'sweetalert2';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { useStateMaster } from '../../../CustomHooks/useStateMaster';
import { useCity } from '../../../CustomHooks/useCity';
import { ConfigurationContext } from '../../../Context/ConfigurationContext';

let siteObj = {
  SiteID: 0,
  SiteName: "",
  BranchID: "",
  SiteAddress: "",
  clientID: 0,
  AddCustomerName: "",
  StateName: 0,
  CityName: "",
  SiteRegionName: "",
  SitePincode: "",
  SiteArea: "",
  SiteModeID: 0,
};

const SiteAdditionForm = ({ setShowAddSite, isDarkTheme, selectedRow, selectedCustomer, handleApplyFilters, fetchFilters }) => {
  const [show, setShow] = useState(false);
  const [selectedSite, setSelectedSite] = useState(siteObj);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [inputValidationError, setInputValidationError] = useState('');
  const [savebtnClick, setSavebtnClick] = useState(false);

  const { clients } = useContext(ConfigurationContext)
  const { country } = useCountry();
  const { state, getState } = useStateMaster()
  const { city, getCity} = useCity();

  const { siteTypes } = useSiteType();

  const [isAlreadyRetail, setIsAlreadyRetail] = useState(false);

  const [siteError, setSiteError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [stateError, setStateError] = useState('');
  const [cityError, setCityError] = useState('');
  const [regionError, setRegionError] = useState('');
  const [pincodeError, setPincodeError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [areaError, setAreaError] = useState('');
  const [branchidError, setBranchidError] = useState('');
  const [siteModeIdError, setSiteModeIdError] = useState('');

  useEffect(() => {
    if(selectedRow){
      setSelectedSite(selectedRow)
    }
  },[selectedRow])

  const {
    register,
    handleSubmit,
    setValue,
    formState: { isDirty, touchedFields },
  } = useForm({ defaultValue: { ...selectedSite } });

  useEffect(() => {
    setValue('CountryName', selectedSite?.countrymasterid || 0)
    getState(selectedSite?.countrymasterid)
    if(selectedSite.StateName != 0){
      getCity(selectedSite.statemasterid);
    }
    setValue("clientID", selectedSite.clientID || selectedSite.ClientId);
    setValue("SiteName", selectedSite.SiteName);
    setValue("BranchID", selectedSite.BranchID);
    setValue("SiteAddress", selectedSite.SiteAddress || selectedSite.Address);
    setValue("CityName", selectedSite.City || '0');
    setValue("SiteRegionName", selectedSite.Region);
    setValue("SitePincode", selectedSite.pincode || selectedSite.PinCode);
    // setValue("SiteAddress", selectedSite.Address);
    setValue("SiteArea", selectedSite.Area);
    setValue("SiteModeID", selectedSite.SiteModeID)

    if (selectedSite.SiteModeID == 2) {
      setIsAlreadyRetail(true);
    } else {
      setIsAlreadyRetail(false);
    }
  }, [selectedSite])

    useEffect(() => {
      if(selectedRow != null){
        setValue('CountryName', selectedSite?.countryname)
      }
    }, [country])

    useEffect(() => {
      if(selectedRow != null){
        setValue("SiteModeID", selectedSite.SiteModeID)              
      }
    }, [siteTypes])

    useEffect(() => {
      if(selectedRow != null){
        let tempCountryStateDetails = state?.filter(item => {
          return item.statemasterid == selectedSite.statemasterid
        })
        if (tempCountryStateDetails?.length > 0) {
          setValue("StateName", tempCountryStateDetails[0].statename);
        } else {
          setValue("StateName", selectedSite.StateName);
        }
      }
    }, [state])

    useEffect(() => {
      if(selectedRow != null){
        if(selectedSite.StateName == ""){
        setValue("CityName", '0');
        }else{
        let isPresent = city.find((item) => item.CityName == selectedSite.City)  
        if(isPresent == undefined){
          setValue("CityName", '0');
        }else{
          setValue("CityName", selectedSite.City);
        }
        }
      }
    }, [city])

    const clearForm = () => {
      setValue("SiteName", '');
      setValue('CountryName', '0')
      setValue("StateName", '0');
      setValue("CityName", '0');
      setValue("SiteRegionName", '');
      setValue("SitePincode", '');
      setValue("SiteAddress", '');
      setValue("SiteArea", '');
      setValue("BranchID", '');
      setValue("SiteModeID", '0')
    }

  const onSaveSite = async (data, id, siteData) => {
    setButtonDisable(true);
    // let clientID = data.clientID;
    let clientID = selectedCustomer.value
    let sitename = data.SiteName.toString().trim();
    let countryName = data.CountryName;
    let stateName = data.StateName;
    let cityName = data.CityName;
    let siteRegionName = data.SiteRegionName;
    let sitePincode = data.SitePincode;
    let siteaddress = data.SiteAddress?.toString().trim();
    let siteaArea = data.SiteArea?.toString().trim();
    let branchid = data.BranchID;
    let SiteModeID = parseInt(data.SiteModeID);
    let SiteMode = data.SiteMode;
    let user = JSON.parse(localStorage.getItem("user"));
    let validationError = "";

    if (clientID === "" || clientID == null || clientID == 0) {
      validationError += "customer-Please select customer name!,";
    }
    if (sitename === "") {
      validationError += "site-Please enter site name!,";
    }
    if (
      countryName === "" ||
      countryName == null ||
      countryName == 0 ||
      countryName == undefined
    ) {
      validationError += "country-Please select country name!,";
    }
    if (
      stateName === "" ||
      stateName == null ||
      stateName == 0 ||
      stateName == undefined
    ) {
      validationError += "state-Please select state name!,";
    }
    if (cityName === "" || cityName === null || cityName == 0 || cityName === undefined) {
      validationError += "city-Please enter city name!,";
    }
    if (siteRegionName === "" || siteRegionName === undefined) {
      validationError += "region-Please enter region name!,";
    }
    if (sitePincode === "" || sitePincode === undefined) {
      validationError += "pincode-Please enter pincode!,";
    }
    if (siteaddress === "" || siteaddress === undefined) {
      validationError += "address-Please enter address!,";
    }
    if (siteaArea === "" || siteaArea === undefined) {
      validationError += "area-Please enter area!,";
    }
    if (branchid === "" || branchid === undefined) {
      validationError += "branchid-Please enter branch ID!,";
    }
    // if (SiteModeID === "" || SiteModeID === undefined || SiteModeID == 0) {
    //   validationError += "siteModeId-Please select site type!,";
    // }
    if (checkspecialcharacters(sitename)) {
      ErrorToast("Special characters are not allowed in site name!");
      setButtonDisable(false);
      return;
    }
    setInputValidationError(validationError);
    setSavebtnClick(true);
    if (validationError != "") {
      setButtonDisable(false);
      return;
    }
    let myCurrentDatetime = new Date();
    let datetime = ConvertDate(myCurrentDatetime);

    var _lat = 0;
    var _long = 0;
    var objNearByResources = {
      SearchPlace: siteaddress,
      radius: 0,
      lat: 0,
      long: 0,
      SearchType: "PlaceDetails",
    };
    if (!HIDE_ANALYTICS) {
      await nearbyresource(objNearByResources).then((resp1) => {

        if (resp1.status == "Ok") {
          if (resp1.message.length > 0) {
            _lat = resp1.message[0].siteLattitude;
            _long = resp1.message[0].siteLongitude;
          }
        }
      });
    }


    let tempCountryName = country.filter((item) => {
      return item.countryname == countryName;
    });

    let tempCountryStateName = state.filter(
      (item) => item.statename === stateName
    );
    // Add Camera
    if (id == 0) {
      let siteObj = {
        UserID: user.Id,
        ParentID: "",
        SiteName: sitename.toString().trim(),
        Lattitude: _lat.toString(),
        Longitude: _long.toString(),
        PinUrl: "",
        Alt: "",
        IsBingMap: "",
        BranchID: branchid.toString().trim(),
        SolID: "",
        SiteModeID: "1",
        SiteTypeID: "2",
        TopicArn: "",
        ClientId: clientID.toString(),
        OrganizationMasterID: user.OrganizationMasterID.toString(),
      };
      // Site Mode Id - 2 is for Retail Site
      if (SiteModeID == 2) {
        Swal.fire({
          title: "Note",
          text: "You are adding this site as a retail store, once added you will not be able to change it.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#027aaa",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok!",
          allowOutsideClick: false,
        })
          .then((result) => {
            if (result.isConfirmed) {
              addSiteDetails(
                siteObj,
                siteaddress,
                tempCountryName,
                tempCountryStateName,
                siteRegionName,
                siteaArea,
                cityName,
                sitePincode,
                user,
                sitename,
                branchid,
                clientID,
                SiteModeID
              );
            } else {
              setButtonDisable(false);
            }
          })
          .catch((err) => console.log(err));
      } else {
        addSiteDetails(
          siteObj,
          siteaddress,
          tempCountryName,
          tempCountryStateName,
          siteRegionName,
          siteaArea,
          cityName,
          sitePincode,
          user,
          sitename,
          branchid,
          clientID,
          SiteModeID
        );
      }
    } else {
      //update
      //Check if siteid was set or not before
      let updateObj = {
        UserID: user.Id,
        SiteID: id.toString(),
        ParentID: "",
        SiteName: sitename,
        Lattitude: _lat.toString(),
        Longitude: _long.toString(),
        PinUrl: "",
        Alt: "",
        IsBingMap: "",
        BranchID: branchid.toString().trim(),
        SolID: "",
        // SiteModeID: SiteModeID.toString(),
        SiteModeID: "1",
        SiteTypeID: "2",
        TopicArn: "",
        ClientId: clientID.toString(),
        OrganizationMasterID: user.OrganizationMasterID.toString(),
        CreatedOn: "",
        CreatedBy: "",
        ModifiedOn: "",
        ModifiedBy: user.Id,
        UpdatedateTime: "",
      };
      if (selectedSite.SiteModeID != 2 && SiteModeID == 2) {
        // It means that we are changing the site type to retail.
        Swal.fire({
          title: "Note",
          text: "You are updating this site as a retail store, once updated you will not be able to change it.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#027aaa",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok!",
          allowOutsideClick: false,
        })
          .then((result) => {
            if (result.isConfirmed) {
              updateSiteDetails(
                updateObj,
                siteData,
                siteaddress,
                tempCountryName,
                tempCountryStateName,
                siteRegionName,
                siteaArea,
                cityName,
                sitePincode,
                user
              );
            } else {
              setButtonDisable(false);
            }
          })
          .catch((err) => console.log(err));
      } else {
        updateSiteDetails(
          updateObj,
          siteData,
          siteaddress,
          tempCountryName,
          tempCountryStateName,
          siteRegionName,
          siteaArea,
          cityName,
          sitePincode,
          user
        );
      }
    }
  };

  const addSiteDetails = (
    siteObj,
    siteaddress,
    tempCountryName,
    tempCountryStateName,
    siteRegionName,
    siteaArea,
    cityName,
    sitePincode,
    user,
    sitename,
    branchid,
    clientID,
    SiteModeID
  ) => {
    Addsitedetails(siteObj).then((resp) => {
      if (resp.Status == "success") {
        //Here to add in site address table.
        let addressObj = {
          Siteid: resp.Data.SiteID.toString(),
          Address: siteaddress.toString().trim(),
          Countryid: tempCountryName[0].countrymasterid.toString(),
          Stateid: tempCountryStateName[0].statemasterid.toString(),
          Region: siteRegionName.toString().trim(),
          Area: siteaArea.toString().trim(),
          City: cityName.toString().trim(),
          PinCode: sitePincode,
          CreatedOn: "",
          ModifiedON: "",
          Createdby: user.Id,
          ModifiedBy: "",
          OrganizationMasterID: user.OrganizationMasterID.toString(),
          UpdatedateTime: "",
          UserID:user.Id
        };
        addSiteAddress(addressObj).then((res) => {
          if (res.Status == "success") {
            // getSites();
            // SuccessToast(resp.Message);
            addZone(resp.Data.SiteID, siteObj, addressObj)
            addInterface(resp.Data.SiteID, siteObj)
            setButtonDisable(false);
            clearForm();
            // let tempObj = {
            //   SiteID: resp.Data.SiteID,
            //   SiteName: sitename,
            //   BranchID: branchid,
            //   Address: siteaddress,
            //   clientID: clientID,
            //   AddCustomerName: "",
            //   CountryId: tempCountryName[0].countrymasterid,
            //   StateId: tempCountryStateName[0].statemasterid,
            //   City: cityName,
            //   Region: siteRegionName,
            //   pincode: sitePincode,
            //   Area: siteaArea,
            //   SiteModeID: SiteModeID,
            // };
            // setSelectedSite(tempObj);
            window.scrollTo({ top: 500, left: 0, behavior: "smooth" });
            setTimeout(() => {
              let siteDiv = document.getElementById("siteListDiv");
              siteDiv.scrollTo({
                top: siteDiv.scrollHeight,
                behavior: "smooth",
              });
            }, 1000);
          } else {
            ErrorToast(resp.Message);
            setButtonDisable(false);
          }
        });
      } else {
        ErrorToast(resp.Message);
        setButtonDisable(false);
      }
    });
  };

  const updateSiteDetails = (
    updateObj,
    siteData,
    siteaddress,
    tempCountryName,
    tempCountryStateName,
    siteRegionName,
    siteaArea,
    cityName,
    sitePincode,
    user
  ) => {
    Updatesitedetails(updateObj).then((resp) => {
      if (resp.Status == "success") {
        let updateAddressObj = {
          AddressId: siteData.AddressId.toString(),
          Siteid: resp.Data.SiteID.toString(),
          Address: siteaddress.toString().trim(),
          Countryid: tempCountryName[0].countrymasterid.toString(),
          Stateid: tempCountryStateName[0].statemasterid.toString(),
          Region: siteRegionName.toString().trim(),
          Area: siteaArea.toString().trim(),
          City: cityName,
          PinCode: sitePincode,
          CreatedOn: "",
          ModifiedON: "",
          Createdby: "",
          ModifiedBy: user.Id,
          OrganizationMasterID: user.OrganizationMasterID.toString(),
          UpdatedateTime: "",
          UserID:user.Id
        };
        updateSiteAddress(updateAddressObj).then((res) => {
          if (res.Status == "success") {
            // getSites();
            setButtonDisable(false);
            SuccessToast(resp.Message);
            handleApplyFilters()
            fetchFilters()
          } else {
            ErrorToast(resp.Message);
            setButtonDisable(false);
          }
        });
      } else {
        ErrorToast(resp.Message);
        setButtonDisable(false);
      }
    });
  };

  const addZone = (parentSiteId, siteObj, addressObj) => {
    siteObj['ParentID'] = parentSiteId.toString();
    siteObj['SiteName'] = `${siteObj.SiteName} - Zone`;
    // siteObj['BranchID'] = siteObj.BranchID + " - Zone";
    siteObj['SiteTypeID'] = "3"; 
    Addsitedetails(siteObj).then((resp) => {
      if(resp.Status == "success"){
        addressObj['Siteid'] = resp.Data.SiteID.toString();
        addSiteAddress(addressObj)
          .then((res) => {
            if (res.Status == "success") {
              SuccessToast("Site added successfully");
              handleApplyFilters();
              fetchFilters()
              setButtonDisable(false);
            } else {
              ErrorToast(res.Message);
              setButtonDisable(false);
            }
          })
          .catch((err) => {
            setButtonDisable(false);
          })
      }
    })
  }


  const addInterface = (siteId, siteObj) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let addInterfaceUAPIObj = {
      "InterfaceName": `${siteObj.SiteName.split(" - ")[0]} - Interface`,
      "InterfacetypeId": 6,
      "InterfacesubtypeId": 17,
      "InterfaceIP": "0",
      "InterfacePort": "0",
      "UserName": "0",
      "Password": "0",
      "siteid": siteId,
      "isTwoWayEnabled": "0",
      "isHooterEnabled": "0",
      "CheckInternalHooter": "0",
      "CheckExternalHooter": "0",
      "LiveRTSPURL": "1",
      "PlaybackRTSPURL": "1",
      "CheckPlaybackUTCTime": "",
      "CheckPlaybackLongTime": "",
      "EntityTypeID": 11,
      "TimeZoneID": 1,
      "OrganizationMasterID": 1,
      "UpdatedateTime": "",
      "InternetProtocolPort": 8000,
      "Communicationport": 9090,
      "UserId": user.Id,
      "SerialNo": siteId.toString(),
      "UserID": user.Id
    };

    addInterfaceDetails(addInterfaceUAPIObj).then((resp) => {
      if (resp.Status == "success") {
        console.log("Interface added successfully");
      } else {
        console.log(resp.Message);
      }
    }).catch((err) => {
      console.log(err);
    })
      
    
  }

  const handleCountryChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedCountryValue = selectedOption.value;
    const selectedCountryValueId = selectedOption.getAttribute('id');
    getState(selectedCountryValueId)
  }

  const handleStateChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedStateValueId = selectedOption.getAttribute('id');
    getCity(selectedStateValueId)
  }

  useEffect(() => {
    if (savebtnClick) {
      let templst = inputValidationError.split(",");
      for (let i = 0; i < templst.length; i++) {

        if (templst[i].includes("site-")) {
          setSiteError(templst[i].replace("site-", ""));
          continue
        }

        if (templst[i].includes("country-")) {
          setCountryError(templst[i].replace("country-", ""));
          continue
        }

        if (templst[i].includes("state-")) {
          setStateError(templst[i].replace("state-", ""));
          continue
        }

        if (templst[i].includes("city-")) {
          setCityError(templst[i].replace("city-", ""));
          continue
        }

        if (templst[i].includes("region-")) {
          setRegionError(templst[i].replace("region-", ""));
          continue
        }

        if (templst[i].includes("pincode-")) {
          setPincodeError(templst[i].replace("pincode-", ""));
          continue
        }

        if (templst[i].includes("address-")) {
          setAddressError(templst[i].replace("address-", ""));
          continue
        }

        if (templst[i].includes("area-")) {
          setAreaError(templst[i].replace("area-", ""));
          continue
        }

        if (templst[i].includes("branchid-")) {
          setBranchidError(templst[i].replace("branchid-", ""));
          continue
        }

        if (templst[i].includes("siteModeId-")) {
          setSiteModeIdError(templst[i].replace("siteModeId-", ""));
          continue
        }
      }
      setSavebtnClick(false)
    }
  }, [savebtnClick]);

  return (
    <>
      {/* This component is used to add a new site */}
      <div className="SiteMainContainer SiteTableMainDiv p-2">
        <h5>{selectedRow == null ? 'Add site' : 'Edit site'}</h5>
        {/* Add your form components here */}
              <div className='SiteFormAdditionForm'>
                <form style={{ width: "100%" }}>
                  <div className="site-form">

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Customer Name</label>
                        <input
                        type="text"
                        className="inputType"
                        disabled={true}
                        placeholder="Add Customer"
                        value={selectedCustomer ? selectedCustomer.label : ""}
                        // {...register("AddCustomerName")}
                        // onChange={(e) => setAddCustomerError('')}
                        />
                        {/* <select
                                        required
                                        // disabled={true}
                                        {...register("clientID")}
                                        className="inputType ArrowSelectClass"
                                        // defaultValue={site?.ClientId}
                                        onChange={(e) => {
                                          setValue("clientID", e.target.value);
                                        }}
                                      >
                                        <option key="0" disabled={false} value="0">Select Customer*</option>
                                        {clients &&
                                          clients.map((val) => (
                                            <option value={val.ClientId} key={val.ClientName}>
                                              {val.ClientName}
                                            </option>
                                          ))}
                                      </select> */}

                        <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Site Name*</label>
                        <input
                          {...register("SiteName")}
                          className="inputType"
                          placeholder="Site Name*"
                          onKeyPress={(e) => {
                            onSpecialChangeOnly(e);
                            setSiteError('')
                          }}
                          onChange={() => { setSiteError('') }}
                        />
                        <p className="Error_P" style={{ float: "left" }}><span>{siteError}</span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Select Country*</label>
                        <select
                          {...register("CountryName")}
                          className="inputType ArrowSelectClass"
                          onChange={(e) => {
                            handleCountryChange(e)
                            setCountryError('')
                          }}
                        >
                          <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                          {country &&
                            country.map((val) => (
                              <option value={val.countryname} key={val.countrymasterid} id={val.countrymasterid}>
                                {val.countryname}
                              </option>
                            ))}
                        </select>
                        <p className="Error_P" style={{ float: "left" }}><span> {countryError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Select State*</label>
                        <select
                          {...register("StateName")}
                          className="inputType ArrowSelectClass"
                          onChange={(event) => {
                            handleStateChange(event)
                            setValue("CityName", '0');
                            setStateError('')
                          }}
                        >
                          <option key="0" disabled={false} value="0">Select State*</option>
                          {state &&
                            state.map((val) => (
                              <option value={val.statename} key={val.statemasterid} id={val.statemasterid}>
                                {val.statename}
                              </option>
                            ))}                        </select>
                        <p className="Error_P" style={{ float: "left" }}><span> {stateError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>City*</label>
                        <select
                          {...register("CityName")}
                          className="inputType ArrowSelectClass"
                          onChange={() => {
                            setCityError('')
                          }}
                        >
                          <option key="0" disabled={false} value="0">Select City*</option>
                          {city &&
                            city.map((val) => (
                              <option value={val.CityName} key={val.CityID}>
                                {val.CityName}
                              </option>
                            ))}
                        </select>
                        <p className="Error_P" style={{ float: "left" }}><span> {cityError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Address*</label>
                        <input
                          maxLength={100}
                          {...register("SiteAddress")}
                          className="inputType"
                          placeholder="Address*"
                          onChange={() => setAddressError('')} />
                        <p className="Error_P" style={{ float: "left" }}><span> {addressError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Pin Code*</label>
                        <input
                          {...register("SitePincode")}
                          className="inputType"
                          onKeyPress={(e) => {
                            onNumberOnlyChange(e);
                            setPincodeError('')
                          }}
                          onChange={() => { setPincodeError('') }}
                          placeholder="Pin Code*" />
                        <p className="Error_P" style={{ float: "left" }}><span> {pincodeError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Region*</label>
                        <input
                          {...register("SiteRegionName")}
                          className="inputType"
                          placeholder="Region*"
                          onKeyPress={(e) => {
                            onSpecialChangeOnly(e);
                            setRegionError('')
                          }}
                          onChange={() => { setRegionError('') }}
                        />
                        <p className="Error_P" style={{ float: "left" }}><span> {regionError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Area*</label>
                        <input
                          {...register("SiteArea")}
                          className="inputType"
                          placeholder="Area*"
                          onKeyPress={(e) => {
                            onSpecialChangeOnly(e);
                            setAreaError('')
                          }}
                          onChange={() => { setAreaError('') }} />
                        <p className="Error_P" style={{ float: "left" }}><span> {areaError} </span></p>
                      </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Branch ID*</label>
                        <input
                          maxLength={50}
                          {...register("BranchID")}
                          className="inputType"
                          placeholder="Branch ID*"
                          onKeyPress={(e) => {
                            onSpecialChangeOnly(e);
                            setBranchidError('')
                          }}
                          onChange={() => { setBranchidError('') }} />
                        <p className="Error_P" style={{ float: "left" }}><span> {branchidError} </span></p>
                      </div>
                    </div>

                    {/* <div className="inputMainContainer w40dot75rem mt35">
                      <div className="inputTypeLabelContainer">
                        <label className='formFieldLabels'>Select Site Type</label>
                        <select className="inputType ArrowSelectClass"
                          {...register("SiteModeID")}
                          disabled={isAlreadyRetail}
                          // defaultValue={site.SiteModeID}
                          onChange={(e) => { setValue("SiteModeID", e.target.value); setSiteModeIdError('') }}
                        >
                          <option key="0" disabled={false} value={0} id="0"> Site Type</option>
                          {siteTypes &&
                            siteTypes.map((val) => (
                              <option value={val.SiteModeID} key={val.SiteModeID}>
                                {val.SiteMode}
                              </option>
                            ))}
                        </select>
                        <p className="Error_P" style={{ float: "left" }}><span> {siteModeIdError} </span></p>
                      </div>
                    </div> */}

                  </div>
                </form>
              </div>

              <div style={{ textAlign: "center" }}>
                <button className="DataAccessEdit" disabled={buttonDisable} style={{ width: "100px" }} onClick={handleSubmit((e) => onSaveSite(e, selectedSite.SiteID, selectedSite))}>
                  <span className="ViewUpdate">Save</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setShowAddSite(false)}>
                  <span className="ViewUpdate">Cancel</span>
                </button>
              </div>
      </div>


      <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-90w" backdrop="static" className="AddCustomerModal">
        <>
          <Modal.Header >
            <Modal.Title id="example-custom-modal-styling-title">
              Add Customer
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
            />
          </Modal.Header>

          <Modal.Body>
            <div className="inputMainContainer w40dot75rem w-100">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Customer Name</label>
                <input style={{ width: "40vw" }}
                  type="text"
                  className="inputType"
                  placeholder="Add Customer" />
                <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button className="DataAccessEdit mt-3" style={{ width: "200px" }}>
                <span className="ViewUpdate">Add</span>
              </button>
            </div>
          </Modal.Body>
        </>
      </Modal>

    </>
  )
}

export default SiteAdditionForm